var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audioplayer",class:{ playing: _vm.playing }},[_c('button',{staticClass:"audioplayer__button",on:{"click":_vm.togglePlay}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.buttonText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }